<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Tipo de Cadastro</label>
                    <b-form-select
                            :options="tiposCadastro"
                            v-model="tipoSeguroGarantiaContrato"
                            text-field="name"
                            value-field="id"
                        ></b-form-select>
                        <b-form-invalid-feedback>
                            O Tipo de Registro é obrigatório
                        </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.valor.$error ? false : null"
                    :invalid-feedback="mensagemErroValor"
                >
                    <label class="required">Valor</label>
                    <money
                        v-model="valor"
                        v-bind="money"
                        class="form-control text-right"
                        @input.native="$v.valor.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label>Percentual (%)</label>
                    <b-form-input
                        type="text"
                        :value="percentualFormatado"
                        disabled
                        class="form-control text-right"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="3"
                        @input="$v.descricao.$touch()"
                        :state="$v.descricao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A descrição é obrigatória
                    </b-form-invalid-feedback
                    >
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label>Número da Apólice</label>
                    <b-input-group>
                        <b-form-input
                            type="text"
                            v-model="numeroApolice"
                            :state="$v.numeroApolice.$error ? false : null"
                            @input.native="$v.numeroApolice.$touch()"
                        ></b-form-input>
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.dataVencimento.$error ? false : null"
                    :invalid-feedback="mensagemErroDataVencimento"
                >
                    <label :class="{required: $v.dataVencimento.$invalid}">Data de Vencimento</label>
                    <date-picker
                        v-model="dataVencimento"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        :readonly="tipoOperacao === 'i'"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Data do Aviso de Vencimento</label>
                    <date-picker
                        v-model="dataDoAvisoDeVencimento"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                    ></date-picker>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label :class="{required: $v.documentoComprobatorio.$invalid}">Documento Comprobatório</label>
                    <b-form-file
                        v-model="documentoComprobatorio"
                        placeholder="Selecione o documento comprobatório..."
                        ref="documentoInput"
                        browse-text="Selecionar"
                        :disabled="$v.documentoComprobatorio === null || $v.documentoComprobatorio === ''"
                    ></b-form-file>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                :disabled="desabilitarBtnSalvar"
            >
                Salvar
            </b-button
            >
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import SegurosServicos from './SegurosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },

        seguro: {
            type: Object,
            default: () => ({})
        },

        tipoOperacao: {
            type: String,
            default: () => ''
        },

        showModal: {
            type: Boolean,
            default: () => false
        },
    },

    data() {
        return {
            erros: [],
            mostrarModal: false,
            tipoSeguroGarantiaContrato: null,
            descricao: null,
            numeroApolice: null,
            dataVencimento: null,
            dataDoAvisoDeVencimento: null,
            documentoComprobatorio: null,
            nomeDocumento: null,
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            tiposCadastro: [
                { id: 0, name: 'Seguro' },
                { id: 1, name: 'Garantia' }
            ]
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.resetFormulario()
            this.$emit('modalFechado')
        },

        resetFormulario() {
            this.erros = []
            this.tipoSeguroGarantiaContrato = null
            this.descricao = null
            this.numeroApolice = null
            this.dataVencimento = null
            this.dataDoAvisoDeVencimento = null
            this.documentoComprobatorio = null
            this.valor = 0
            this.$nextTick(() => {
                this.$v.$reset()
                if (this.tipoOperacao == 'i' && this.contrato && this.contrato.dtFimVigencia) {
                    this.dataVencimento = this.$moment(this.contrato.dtFimVigencia).format('DD/MM/YYYY')
                }
            })
        },

        preencherForm() {
            if (this.tipoOperacao == 'a') {
                this.obterSeguro()
            } else if (this.tipoOperacao == 'i') {
                if (this.contrato && this.contrato.dtFimVigencia) {
                    this.dataVencimento = this.$moment(this.contrato.dtFimVigencia).format('DD/MM/YYYY')
                }
            }
        },

        obterSeguro() {
            this.$store.dispatch('addRequest')
            SegurosServicos.obterSeguro(
                this.contrato.idContrato,
                this.seguro.idSeguroGarantiaContrato
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.tipoSeguroGarantiaContrato = response.data.tipoSeguroGarantiaContrato
                        this.valor = response.data.valor
                        this.descricao = response.data.descricao
                        this.numeroApolice = response.data.numeroApolice
                        this.dataDoAvisoDeVencimento = response.data.dataDoAvisoDeVencimento != null
                            ? this.$moment(response.data.dataDoAvisoDeVencimento).format('DD/MM/YYYY')
                            : null
                        this.dataVencimento = response.data.dataVencimento != null
                            ? this.$moment(response.data.dataVencimento).format('DD/MM/YYYY')
                            : null
                        this.documentoComprobatorio = response.data.documentoComprobatorio
                    } else {
                        this.$toast.error(
                            'Erro ao obter a manutenção',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        dataVencimentoValida() {
            if (this.numeroApolice === '' || this.numeroApolice === null) {
                return true;
            } else {
                if (this.dataVencimento === '' || this.dataVencimento === null || this.dataVencimento === 'Invalid date') {
                    return false;
                } else {
                    return true;
                }
            }
        },

        dataVencimentoIgualFimVigencia() {
            if (!this.contrato || !this.contrato.dtFimVigencia) {
                return true;
            }

            if (!this.dataVencimento || this.dataVencimento === 'Invalid date' || this.dataVencimento === '') {
                return false;
            }

            const dataFimVigencia = this.$moment(this.contrato.dtFimVigencia).format('DD/MM/YYYY')
            const dataVencimentoFormatada = this.$moment(this.dataVencimento, 'DD/MM/YYYY').format('DD/MM/YYYY')

            return dataFimVigencia === dataVencimentoFormatada
        },

        documentoComprobatorioValido() {
            if (this.numeroApolice === '' || this.numeroApolice === null) {
                return true;
            } else {
                if (this.documentoComprobatorio !== null && this.documentoComprobatorio !== '') {
                    return true;
                } else {
                    return false;
                }
            }
        },

        valorMaiorQueZero() {
            return this.valor !== null && this.valor !== undefined && this.valor > 0;
        },

        percentualValido() {
            if (this.valor === null || this.valor === undefined || this.valor === 0) {
                return true;
            }
            if (this.valorTotal === 0) {
                return true;
            }
            return this.percentual <= 10;
        },

        confirmarSalvar() {
            let msg
            if (this.tipoOperacao == 'i') {
                msg = 'Confirma a inserção do Seguro/Garantia?'
            } else {
                msg = 'Confirma a atualização do Seguro/Garantia?'
            }

            if (this.percentual > 5) {
                const percentualFormatado = this.percentual.toFixed(2).replace('.', ',');
                msg += `<br><br>O percentual de garantia calculado é ${percentualFormatado}%. Tem certeza que deseja enviar este percentual?`
            }

            this.$swal({
                title: 'Seguros/Garantias',
                html: msg,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let seguroDto = {
                tipoSeguroGarantiaContrato: this.tipoSeguroGarantiaContrato,
                valor: this.valor,
                descricao: this.descricao,
                numeroApolice: this.numeroApolice ? this.numeroApolice : '',
                dataVencimento: this.dataVencimento
                    ? this.$moment(this.dataVencimento, 'DD/MM/YYYY').toISOString()
                    : '',
                documentoComprobatorio: this.documentoComprobatorio,
                idContrato: this.contrato.idContrato,
                dataDoAvisoDeVencimento: this.dataDoAvisoDeVencimento
                    ? this.$moment(this.dataDoAvisoDeVencimento, 'DD/MM/YYYY').toISOString()
                    : '',
            }

            let promisse
            if (this.tipoOperacao == 'i') {
                promisse = SegurosServicos.inserir(seguroDto)
            } else {
                seguroDto = { ...seguroDto, idSeguroGarantiaContrato: this.seguro.idSeguroGarantiaContrato }
                promisse = SegurosServicos.atualizar(this.contrato.idContrato, seguroDto)
            }

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterSegurosAtualizados')
            this.fecharModal()
        },
    },

    created() {
        this.preencherForm()
    },

    computed: {
        operacao() {
            switch (this.tipoOperacao) {
                case 'i':
                    return 'INSERIR'
                case 'a':
                    return 'ATUALIZAR'
                default:
                    break
            }
        },

        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        valorTotal() {
            return this.contrato && this.contrato.nuValorGlobalContrato ? this.contrato.nuValorGlobalContrato : 0;
        },

        percentual() {
            if (this.valor === null || this.valor === undefined || this.valor === 0 || this.valorTotal === 0) {
                return 0;
            }
            return (this.valor / this.valorTotal) * 100;
        },

        percentualFormatado() {
            if (this.percentual === 0) {
                return '0,00%';
            }
            return this.percentual.toFixed(2).replace('.', ',') + '%';
        },

        mensagemErroValor() {
            if (this.$v.valor.$error) {
                if (!this.$v.valor.required || !this.$v.valor.valorMaiorQueZero) {
                    return 'Valor é obrigatório'
                } else if (!this.$v.valor.percentualValido) {
                    return 'Percentual acima de 10%'
                }
            }
            return ''
        },

        mensagemErroDataVencimento() {
            if (!this.$v.dataVencimento.$error) {
                return ''
            }

            if (
                this.$v.dataVencimento.dataVencimentoIgualFimVigencia !== undefined &&
                !this.$v.dataVencimento.dataVencimentoIgualFimVigencia
            ) {
                const dataFormatada = this.$moment(this.contrato.dtFimVigencia).format('DD/MM/YYYY');
                return 'A data de vencimento deve ser igual à data de fim da vigência do contrato: ' + dataFormatada
            }

            if (
                this.$v.dataVencimento.numeroApolice !== undefined &&
                !this.$v.dataVencimento.numeroApolice
            ) {
                return 'Data de vencimento é obrigatória quando há número de apólice'
            }

            return 'Data de vencimento inválida'
        }
    },

    watch: {
        showModal(newValue) {
            this.mostrarModal = newValue
            if (newValue && this.tipoOperacao == 'i' && this.contrato && this.contrato.dtFimVigencia) {
                this.$nextTick(() => {
                    this.dataVencimento = this.$moment(this.contrato.dtFimVigencia).format('DD/MM/YYYY')
                })
            }
        },
        dataVencimento(newValue) {
            this.$nextTick(() => {
                this.$v.dataVencimento.$touch()
            })
        }
    },

    validations: {
        tipoSeguroGarantiaContrato: {
            required
        },
        valor: {
            required,
            valorMaiorQueZero() {
                return this.valorMaiorQueZero();
            },
            percentualValido() {
                return this.percentualValido();
            }
        },
        descricao: {
            required
        },
        numeroApolice: {

        },
        dataVencimento: {
            numeroApolice() {
                return this.dataVencimentoValida();
            },
            dataVencimentoIgualFimVigencia() {
                return this.dataVencimentoIgualFimVigencia();
            }
        },
        documentoComprobatorio: {
            numeroApolice() {
                return this.documentoComprobatorioValido();
            }
        },
        dataDoAvisoDeVencimento: {
            required
        }
    }
}
</script>
<style scoped>
    .modal-footer {
        justify-content: flex-end;
        padding: 1rem 0 0 0;
        border-top: 1px solid #c8ced3;
    }
</style>
